import { useEffect, useState } from "react";
import { isSoundOn, onSound, setSound } from "../../lib/audio";

export default function AudioToggle() {
  const [on, setOn] = useState(isSoundOn());
  useEffect(() => onSound(setOn), []);
  return (
    <button
      data-testid="audio-toggle"
      onClick={() => setSound(!on)}
      aria-pressed={on}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full border border-gold/40 bg-forest px-4 py-3 backdrop-blur-xl transition-colors hover:border-gold sm:py-2.5 sm:pr-5"
      aria-label={on ? "Turn sound off" : "Turn sound on"}
    >
      <span className="flex h-4 items-end gap-[3px]">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className="w-[3px] rounded-full bg-white"
            style={{ height: on ? undefined : 4, animation: on ? `eq 1.${i + 2}s ease-in-out ${i * 0.15}s infinite alternate` : "none" }}
          />
        ))}
      </span>
      <span className="hidden font-mono text-[11px] uppercase tracking-[0.2em] text-white sm:inline">
        {on ? "Breeze on" : "Sound off"}
      </span>
      <style>{"@keyframes eq{from{height:3px}to{height:16px}}"}</style>
    </button>
  );
}
